import { EntityTemplate, EntityTemplateField } from "../EntityTemplate.types.ts";

export interface TemplateStepFieldGroup {
    stepId: string;
    stepName: string;
    order: number;
    fields: Array<EntityTemplateField>;
}

/**
 * The create dialog shows a subset of a template's fields: the ones the AI extracted, or the ones marked
 * required at creation. Grouping them back under the step they were configured in is what lets the dialog
 * use the customer's own headings instead of a flat standard/custom split.
 */
export function groupFieldsByTemplateStep(template: EntityTemplate | undefined, fields: Array<EntityTemplateField>): Array<TemplateStepFieldGroup> {
    if (!template) {
        return [];
    }

    const includedFieldIds = new Set(fields.map((field) => field.id));

    return template.steps
        .map((step) => ({
            stepId: step.id,
            stepName: step.name,
            order: step.order,
            fields: step.fields.filter((field) => includedFieldIds.has(field.id)).sort((a, b) => a.order - b.order),
        }))
        .filter((group) => group.fields.length > 0)
        .sort((a, b) => a.order - b.order);
}
